import * as gemini from "gemini/gemini.web";
import { castVL2VG } from 'gemini/gemini.web';
import React, { Component } from  'react';
import SequenceView from './SequenceView';
import './css/SequenceCol.css'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons'
import {
  Col, DropdownButton, ButtonGroup, Dropdown
} from 'react-bootstrap'



class VisCol extends Component {

  render() {
    return <Col xs={2} id="seq-col" className="p-0">
      <div className="text-center mt-3 mb-2">
        <span className="d-inline-block">Keyframes</span>
        <DropdownButton
          as={ButtonGroup}
          placeholder="Recommendation"
          variant="primary"
          title={<Icon icon={faLightbulb}></Icon>}
          id={`seq-recom-btn-group`}
          className={"ml-1 seq-recom-btn-group"}
          size="sm"
          onSelect={ async (eventKey, event) => this.onRecomSequenceClick(event, eventKey)}
        >
          <Dropdown.Item eventKey="autoFill">Automate All</Dropdown.Item>
          <Dropdown.Item eventKey="recomPath" disabled={!this.props.keyframeRecommendable}>Recommend Keyframes</Dropdown.Item>
        </DropdownButton>


      </div>

      <SequenceView

        sequence = {this.props.sequence}
        animationSpecs = {this.props.animationSpecs}
        currAnimId = {this.props.currAnimId}
        onChangeCurrAnimId={this.props.onChangeCurrAnimId}
        onChangeSequence={this.props.onChangeSequence}
        showKeyframeModal={this.props.showKeyframeModal}
      />
    </Col>
  }
  async onRecomSequenceClick(event, eventKey) {
    if (eventKey === "recomPath") {
      this.props.showKeyframeModal.bind(this)();
    } else {

      let animSpecs = await gemini.recommendForSeq(this.props.sequence.map(castVL2VG), {
        stageN: this.props.sequence.length -1,
        totalDuration: (this.props.sequence.length -1)*1000 // default
      })
      animSpecs = animSpecs[0].specs.map(s => {
        delete s.spec.meta
        return s.spec;
      });
      this.props.onChangeSequence(this.props.sequence, animSpecs)
    }


  }
}

export default VisCol;



